var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraduate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 21.5,
    r: 21.5,
    fill: "#E6E6E6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(6, 6) scale(0.7)",
    fill: "#033476"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.036 15.237L25.948 6.737a5.029 5.029 0 0 0-3.9 0L1.96 15.237a3 3 0 0 0 0 5.526l7.04 2.977v9.573a4.952 4.952 0 0 0 2.4 4.275 24.964 24.964 0 0 0 25.2 0 4.952 4.952 0 0 0 2.4-4.275v-9.573l3-1.27v4.742a2.488 2.488 0 0 0-.485 4.288 2.491 2.491 0 0 0-1.015 2v2.5a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-2.5a2.491 2.491 0 0 0-1.015-2 2.488 2.488 0 0 0-.485-4.288v-5.588l2.036-.861a3 3 0 0 0 0-5.526ZM43.5 29.5a.5.5 0 1 1-.5-.5.5.5 0 0 1 .5.5Zm0 5.5h-1v-1.5a.5.5 0 0 1 1 0Zm-6.5-1.687a2.947 2.947 0 0 1-1.415 2.551 22.967 22.967 0 0 1-23.17 0 2.947 2.947 0 0 1-1.415-2.551v-8.727l11.052 4.676a5.024 5.024 0 0 0 3.9 0l11.048-4.676Zm8.257-14.392-20.088 8.5a3.019 3.019 0 0 1-2.338 0l-20.088-8.5a1 1 0 0 1 0-1.842l20.088-8.5a3.013 3.013 0 0 1 2.338 0l20.088 8.5a1 1 0 0 1 0 1.842Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraduate);
export default __webpack_public_path__ + "static/media/graduate.895316379542e75f661b3360a911a6c7.svg";
export { ForwardRef as ReactComponent };